import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss']
})
export class PageContainerComponent {
  private _maxHeight: boolean = false;
  get maxHeight(): boolean {
    return this._maxHeight;
  }
  @Input() set maxHeight(v: string | boolean) {
    if (typeof v === 'boolean') {
      this._maxHeight = v;
      return;
    }

    this._maxHeight = v !== undefined;
  }
}
